<template>
    <div>
        
        <div class="panel">
            <div class="panel-header">
                RELATÓRIO ({{cargas[0].pacote[0].descricao || ''}})
            </div>
            <div class="panel-body">

                
                <div class="row">
                    <div class="col-lg-6 col-md-6">

                        <table style="margin-bottom:15px;" v-if="cargas[0].pacote[0]">
                            <tr>
                                <td style="font-weight:500;width:150px;">Transportadora</td>
                                <td>{{cargas[0].pacote[0].cliente.nome || ''}}</td>
                            </tr>
                            <tr>
                                <td style="font-weight:500;">Origem</td>
                                <td>{{cargas[0].pacote[0].origem || ''}}</td>
                            </tr>
                            <tr>
                                <td style="font-weight:500;">Destino</td>
                                <td>{{cargas[0].pacote[0].destino || ''}}</td>
                            </tr>
                            <tr>
                                <td style="font-weight:500;">Embarcador</td>
                                <td>{{cargas[0].pacote[0].embarcador_nome || ''}}</td>
                            </tr>
                        </table>

                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label class="w-100">Orgãos</label>
                        <label v-for="orgao in orgaos" v-bind:key="orgao.id" for="" style="margin-right:15px;"><input type="checkbox" v-model="orgaos_select" :value="[orgao.id, orgao.nome]"> {{orgao.nome}}</label>
                    </div>
                </div>

                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" :id="'customSwitch-prf'" v-model="prf">
                    <label class="custom-control-label" :for="'customSwitch-prf'">Relatório para PRF</label>
                </div>

                <table class="table table-bordered relatorio table-hover" style="margin-bottom:0px;" v-if="prf==true">
                    <thead>
                        <tr>
                            <th class="top">NUM</th>	
                            <th class="top">ITEM</th>
                            <th class="top">DESCRIÇÃO</th>	

                            <th class="top">CAVALO</th>	
                            <th class="top">TARA</th>	
                            <th class="top">CMT</th>	

                            <th class="top">SR (1)</th>
                            <th class="top">TARA</th>
                            <th class="top">LARGURA</th>

                            <th class="top">DNIT</th>
                            <th class="top">PEDIDO PR</th>
                            <th class="top">AET PR</th>	

                            <th class="top">C (m)</th>	
                            <th class="top">L (m)</th>	
                            <th class="top">EXCESSO</th>
                            <th class="top">A (m)</th>	
                            <th class="top">PESO</th>	
                            <th class="top">P (t)</th>
                            
                           
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="carga in cargas" v-bind:key="carga.id">

                            <td valign="top"></td>
                            <td valign="top">{{carga.item}}</td>
                            <td valign="top" style="max-width:250px;">{{carga.nome.substring(0, 40)}}</td>

                            <td valign="top">{{carga.veiculos[0]['placa'] || ''}}</td>
                            <td valign="top">{{carga.veiculos[0]['tara'].toFixed(2).replace('.',',') || ''}}</td>
                            <td valign="top">{{carga.veiculos[0]['cmt'].toFixed(0) || ''}}</td>

                            <td valign="top">{{carga.veiculos[1]['placa'] || ''}}</td>
                            <td valign="top">{{carga.veiculos[1]['tara'].toFixed(2).replace('.',',') || ''}}</td>
                            <td valign="top">{{carga.veiculos[1]['largura'].toFixed(2).replace('.',',') || ''}}</td>

                            <td valign="top"></td>
                            <td valign="top"></td>
                            <td valign="top"></td>
                            
                            <td valign="top" class="conjunto">{{carga.conjunto.conjunto_comprimento.toFixed(2).replace('.',',') || ''}}</td>
                            <td valign="top" class="conjunto">{{carga.conjunto.conjunto_largura.toFixed(2).replace('.',',') || ''}}</td>

                            <td valign="top">{{carga.conjunto.ex_direito.toFixed(2).replace('.',',') || ''}}</td>
                            
                            <td valign="top" class="conjunto">{{carga.conjunto.conjunto_altura.toFixed(2).replace('.',',') || ''}}</td>
                            <td valign="top">{{ carga.peso.toFixed(2).replace('.',',') }}</td>
                            <td valign="top" class="conjunto">{{carga.conjunto.conjunto_pbtc.toFixed(2).replace('.',',') || ''}}</td>
                        
                        </tr>
                    </tbody>
                </table>

                <table class="table table-bordered relatorio table-hover" style="margin-bottom:0px;" v-if="prf==false">
                    <thead>
                        <tr>
                            <th class="top">ITEM</th>	
                            <th class="top">DESCRIÇÃO</th>	
                            <th class="top">CAVALO</th>	
                            <th class="top">SR (1)</th>	
                            <th class="top">SR (3)</th>	
                            <th class="top">C (m)</th>	
                            <th class="top">L (m)</th>	
                            <th class="top">A (m)</th>	
                            <th class="top">P (t)</th>	
                            <th class="top">C (m)</th>	
                            <th class="top">L (m)</th>	
                            <th class="top">A (m)</th>	
                            <th class="top">P (t)</th>	
                            <th class="top" v-for="orgao in orgaos_select" v-bind:key="orgao[0]">{{orgao[1]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="carga in cargas" v-bind:key="carga.id">
                            <td valign="top">{{carga.item}}</td>
                            <td valign="top" style="max-width:250px;">{{carga.nome.substring(0, 40)}}</td>
                            <td valign="top">{{carga.veiculos[0]['placa'] || ''}}</td>
                            <td valign="top">{{carga.veiculos[1]['placa'] || ''}}</td>
                            <td valign="top"><span v-if="carga.veiculos[2]">{{carga.veiculos[2]['placa'] || ''}}</span></td>
                            <td valign="top">{{carga.comprimento.toFixed(2)}}</td>
                            <td valign="top">{{carga.largura.toFixed(2)}}</td>
                            <td valign="top">{{carga.altura.toFixed(2)}}</td>
                            <td valign="top">{{carga.peso.toFixed(2)}}</td>
                            <td valign="top" class="conjunto">{{carga.conjunto.conjunto_comprimento.toFixed(2) || ''}}</td>
                            <td valign="top" class="conjunto">{{carga.conjunto.conjunto_largura.toFixed(2) || ''}}</td>
                            <td valign="top" class="conjunto">{{carga.conjunto.conjunto_altura.toFixed(2) || ''}}</td>
                            <td valign="top" class="conjunto">{{carga.conjunto.conjunto_pbtc.toFixed(2) || ''}}</td>
                            <td valign="top" v-for="orgao in orgaos_select" v-bind:key="orgao[0]">
                                {{BuscarAET(orgao[0], carga.id, carga.fila)}}
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div class="panel-footer">
                <button class="btn btn-secondary">Voltar</button>
            </div>
        </div>
        {{aets}}
    </div>
</template>

<script>
import config from '@/config'

export default {
    name:"relatorio",
    data(){
        return{
            config: config,
            pacote_id: null,
            orgaos:{},
            orgaos_select:[],
            prf:false,
            cargas: {
                pacote:[]
            },
            pacote: {
                
            },
            aets:[]
        }
    },
    methods:{
        ListarOrgaos(){
            this.$http.get(this.config.API+'orgaos')
            .then((response) => {
                this.orgaos = response.data.data;
            });
        },
        Listar(){
            this.$http.get(this.config.API+"cargas/"+this.pacote_id)
            .then(res => {
                
                this.cargas = res.data.data.filter(r => {
                    if(r.conjunto){
                        if(r.conjunto.veiculos){
                            let veiculos = JSON.parse(r.conjunto.veiculos)
                            r['veiculos'] = veiculos
                        }
                    }
               
                    if(r['veiculos']!==undefined){
                        return r
                    }
                })
                console.log(this.cargas)
            })
        },

        BuscarAET(orgao, carga, fila){
            let f = fila.filter(r => {
                if(orgao==r.organ_id && carga==r.carga_id){
                    return r
                }
            })
            if(f[0]){
                return f[0]['numero_aet']
            }
        },
        
    },
    beforeMount(){
        this.pacote_id = this.$route.params.id
        this.Listar()
        this.ListarOrgaos()
    }
}
</script>

<style scoped>
    
    .relatorio{

    }
    .relatorio.table-bordered > thead > tr > th{
        border:1px solid #000;
    }
    .relatorio.table-bordered > tbody > tr > td{
        border:1px solid #000;
    }
    .relatorio tbody tr td, .relatorio thead .tr th{
        font-size:10pt !important;
        padding:4px !important;
        font-weight: 500;
    }

    .top{
        background: #00B050 !important;
        padding:4px;
    }

    .relatorio tr .conjunto{
        background: #FFF2CC;
    }

    .relatorio tr:hover{
        background: #E7ECF2;
    }

    .relatorio tr:hover .conjunto{
        background: #f3e1ac;
    }

    @media print {
        body * {
            visibility: hidden;
        }
        .relatorio * {
            visibility: visible;
        }
        .relatorio {
            position: absolute;
            left: 0;
            top: 0;
        }

        
        @page {size: landscape}
    }

</style>